import { Center, Spinner } from "native-base";
import colors from "theme/colors";

const AppSpinner = ({ height = "700px", size = "lg" }) => {
  return (
    <Center dataTestid="center-container" justifyContent="center" alignItems="center" h={height}>
      <Spinner dataTestid="spinner" size={size} color={colors.secondary.orchid} />
    </Center>
  );
};

export default AppSpinner;
